module.exports = __webpack_public_path__ + "static/lframe-cards-dca5f2ed35c37f00a4b1aba9df1c88e3.png";